/* Bubbly: "Avise-me quando voltar"
   - Página de produto: <bubbly-aviso-stock> (snippets/bubbly-aviso-stock.liquid)
   - Listas de produtos: botão [data-aviso-abrir] (snippets/bubbly-quick-add.liquid) que abre um pop-up
   O pedido é um formulário de cliente do Shopify com etiquetas; o Shopify Flow envia o aviso (docs/aviso-stock.md). */
(function () {
  if (window.bubblyAvisoStock) return;

  // Textos no idioma da página (window.bubblyTextos, definido em layout/theme.liquid); português por omissão
  var TX = window.bubblyTextos || {};
  function tx(chave, pt) {
    return TX[chave] || pt;
  }
  function html(texto) {
    var d = document.createElement('div');
    d.textContent = texto;
    return d.innerHTML;
  }
  var TEXTO = tx('avisoTexto', 'Este artigo está esgotado, mas volta em breve. Deixe o seu email e avisamos assim que chegar.');

  function etiquetas(variantId) {
    return 'aviso-stock,aviso-stock-novo,aviso-stock-' + variantId;
  }

  // Envia o formulário sem sair da página. Se o Shopify pedir verificação (captcha) ou algo falhar,
  // segue o envio normal do formulário.
  function enviar(form, aoConfirmar) {
    var email = form.querySelector('input[type="email"]');
    var erro = form.querySelector('[data-aviso-erro]');
    if (!email || !email.value || !email.checkValidity()) {
      if (erro) erro.classList.remove('hidden');
      if (email) {
        email.setAttribute('aria-invalid', 'true');
        email.focus();
      }
      return;
    }
    if (erro) erro.classList.add('hidden');
    email.removeAttribute('aria-invalid');

    var botao = form.querySelector('button[type="submit"]');
    if (botao) botao.setAttribute('aria-busy', 'true');

    fetch(form.action, { method: 'POST', body: new FormData(form), headers: { Accept: 'text/html' } })
      .then(function (r) {
        if (!r.ok || /\/challenge/.test(r.url) || !/customer_posted=true/.test(r.url)) throw new Error('envio normal');
        aoConfirmar(email.value);
      })
      .catch(function () {
        form.submit();
      });
  }

  function confirmacao(email) {
    var p = document.createElement('p');
    p.className = 'bubbly-aviso__ok';
    p.setAttribute('role', 'status');
    p.textContent = tx('avisoOkEmail', 'Combinado! Avisamos em __EMAIL__ assim que voltar.').replace('__EMAIL__', email);
    return p;
  }

  /* ---------- Página de produto ---------- */
  if (!customElements.get('bubbly-aviso-stock')) {
    customElements.define(
      'bubbly-aviso-stock',
      class extends HTMLElement {
        connectedCallback() {
          var self = this;
          this.form = this.querySelector('form');
          this.contentor = this.closest('.product__info-container') || this.parentElement;
          this.mostrar(!this.classList.contains('hidden'));

          if (this.form) {
            this.form.addEventListener('submit', function (event) {
              event.preventDefault();
              enviar(self.form, function (email) {
                self.form.innerHTML = '';
                self.form.appendChild(confirmacao(email));
              });
            });
          }

          // Produtos com variantes: mostrar/esconder e atualizar a etiqueta quando muda a variante
          if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
            this.cancelar = subscribe(PUB_SUB_EVENTS.variantChange, function (event) {
              if (!event || !event.data || event.data.sectionId !== self.dataset.section) return;
              var variante = event.data.variant;
              if (variante) {
                var tags = self.querySelector('[data-aviso-tags]');
                if (tags) tags.value = etiquetas(variante.id);
              }
              self.mostrar(!!variante && !variante.available);
            });
          }
        }

        disconnectedCallback() {
          if (this.cancelar) this.cancelar();
        }

        mostrar(visivel) {
          this.classList.toggle('hidden', !visivel);
          if (this.contentor) this.contentor.classList.toggle('bubbly-aviso-ativo', visivel);
        }
      }
    );
  }

  /* ---------- Pop-up nas listas de produtos ---------- */
  var modal;

  function criarModal() {
    modal = document.createElement('dialog');
    modal.className = 'bubbly-aviso-modal';
    modal.setAttribute('aria-labelledby', 'BubblyAvisoTitulo');
    modal.innerHTML =
      '<button type="button" class="bubbly-aviso-modal__fechar" aria-label="' + html(tx('avisoFechar', 'Fechar')) + '" data-fechar>&times;</button>' +
      '<div class="bubbly-aviso-modal__produto">' +
      '  <img alt="" width="64" height="64" data-imagem>' +
      '  <p class="bubbly-aviso-modal__nome" id="BubblyAvisoTitulo" data-nome></p>' +
      '</div>' +
      '<form method="post" action="' + ((window.Shopify && Shopify.routes && Shopify.routes.root) || '/') + 'contact#BubblyAvisoModal" accept-charset="UTF-8" id="BubblyAvisoModal" novalidate>' +
      '  <input type="hidden" name="form_type" value="customer">' +
      '  <input type="hidden" name="utf8" value="✓">' +
      '  <input type="hidden" name="contact[tags]" value="" data-aviso-tags>' +
      '  <p class="bubbly-aviso__texto">' + html(TEXTO) + '</p>' +
      '  <div class="field bubbly-aviso__campo">' +
      '    <input class="field__input" id="BubblyAvisoEmail" type="email" name="contact[email]" autocomplete="email"' +
      '      autocapitalize="off" autocorrect="off" placeholder="' + html(tx('avisoEmail', 'O seu email')) + '" required aria-required="true"' +
      '      aria-describedby="BubblyAvisoErro">' +
      '    <label class="field__label" for="BubblyAvisoEmail">' + html(tx('avisoEmail', 'O seu email')) + '</label>' +
      '  </div>' +
      '  <p class="bubbly-aviso__erro hidden" id="BubblyAvisoErro" data-aviso-erro role="alert">' + html(tx('avisoErro', 'Confirme o email, por favor.')) + '</p>' +
      '  <button type="submit" class="button button--full-width button--primary">' + html(tx('avisoBotao', 'Avise-me quando voltar')) + '</button>' +
      '</form>';
    document.body.appendChild(modal);

    modal.addEventListener('click', function (event) {
      // Fechar no botão ou ao clicar fora da caixa
      if (event.target.closest('[data-fechar]') || event.target === modal) modal.close();
    });

    var form = modal.querySelector('form');
    form.addEventListener('submit', function (event) {
      event.preventDefault();
      enviar(form, function (email) {
        form.hidden = true;
        var ok = confirmacao(email);
        ok.setAttribute('data-confirmacao', '');
        form.insertAdjacentElement('afterend', ok);
      });
    });
  }

  function abrirModal(botao) {
    if (!modal) criarModal();
    var form = modal.querySelector('form');
    var anterior = modal.querySelector('[data-confirmacao]');
    if (anterior) anterior.remove();
    form.hidden = false;
    form.querySelector('button[type="submit"]').removeAttribute('aria-busy');
    form.querySelector('[data-aviso-tags]').value = etiquetas(botao.dataset.variantId);
    modal.querySelector('[data-nome]').textContent = botao.dataset.produto || '';
    var img = modal.querySelector('[data-imagem]');
    img.hidden = !botao.dataset.imagem;
    if (botao.dataset.imagem) img.src = botao.dataset.imagem;
    var email = form.querySelector('input[type="email"]');
    if (!email.value && window.bubblyClienteEmail) email.value = window.bubblyClienteEmail;
    modal.showModal();
    email.focus();
  }

  document.addEventListener('click', function (event) {
    var botao = event.target.closest('[data-aviso-abrir]');
    if (!botao) return;
    event.preventDefault();
    event.stopPropagation();
    abrirModal(botao);
  });

  window.bubblyAvisoStock = { abrir: abrirModal };
})();
